import React, { useMemo } from "react";

import cx from "classnames";

import styles from "./TinSelectBlock.module.scss";
import { multiTinLookup } from "../checkoutConstants";
import { getStore } from "../../../shared/utility";

const TinBlock = ({
  className,
  isCommitting,
  onSelect,
  isSelected,
  tinOption,
}) => {
  const targetTin = useMemo(() => {
    if (!tinOption) {
      return null;
    }

    return Object.values(multiTinLookup).find(
      ({ variantTitles }) =>
        variantTitles.indexOf(tinOption.variant_title) !== -1,
    );
  }, [tinOption]);

  const optionName = targetTin?.title || tinOption?.variant_title || "No Tin";
  const isAvailable = tinOption
    ? targetTin?.availableLocations.includes(getStore(window.location.search))
    : true;

  if (!isAvailable) {
    return null;
  }

  // The radio answers on the click, so nothing here waits on the cart. Tiles
  // just go inert until it comes back, so a second pick can't race the first.
  const handleSelect = isSelected || isCommitting ? undefined : onSelect;

  return (
    <div className={cx(styles.tinBlockContainer, className)}>
      {/*
        A second hit area for the radio below, hidden from assistive tech and
        the tab order so each tin still announces as the one control it is.
      */}
      <button
        aria-hidden="true"
        className={cx(styles.imageContainer, isCommitting && styles.inert)}
        onClick={handleSelect}
        tabIndex={-1}
        type="button"
      >
        {tinOption?.image && <img alt="" src={tinOption.image.url} />}
      </button>
      <button
        aria-checked={isSelected}
        className={cx(
          styles.toggle,
          isSelected && styles.active,
          isCommitting && styles.inert,
        )}
        // Deliberately not `disabled` when selected: a disabled control can't
        // take focus, so a keyboard user could never reach the current
        // selection to arrow off it. Re-selecting is a no-op instead.
        onClick={handleSelect}
        role="radio"
        type="button"
      >
        <span aria-hidden="true" className={styles.radioMark} />
        <span className={styles.toggleLabel}>{optionName}</span>
      </button>
      {tinOption?.price && parseFloat(tinOption.price.amount) ? (
        <p className={cx("gkit-p-13 gkit-light gkit-my-0", styles.price)}>
          {tinOption.price.formatted}
        </p>
      ) : null}
    </div>
  );
};

export default TinBlock;
